<template>
  <w-icon-wrapper icon-name='work-attention-icon'>
    <g
      id="_71_Attention_Icon"
      data-name="71 Attention_Icon"
      transform="translate(0 0.404)"
    >
      <path
        id="Pfad_55790"
        data-name="Pfad 55790"
        d="M12-.4a12,12,0,1,0,12,12A12,12,0,0,0,12-.4Zm0,22a10,10,0,1,1,10-10A10.012,10.012,0,0,1,12,21.6Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55791"
        data-name="Pfad 55791"
        d="M11.756,6.6a1,1,0,0,0-1,1v5a1,1,0,0,0,2,0v-5A1,1,0,0,0,11.756,6.6Z"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1545"
        data-name="Ellipse 1545"
        cx="1"
        cy="1"
        r="1"
        transform="translate(10.756 14.596)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconAttention' };
</script>
